import React from 'react';
import { toast } from 'react-toastify';
import i18n from '../i18n';
import { CustomToastContent } from '../components/CustomToastContent';
import { toastOptionsTopRight } from './Enums/ToastOptions';
import { ErrorResponse } from '../models/error-response-model';
import { translateClientValidationError } from './client-validation-error';

/**
 * Показва грешка от бекенда със самото ѝ съобщение, когато има такова.
 *
 * Глобалният интерцептор превежда само кода - errorCode 1 става "Грешно въведени данни" - и изхвърля
 * полето error в конзолата. За повечето екрани това е достатъчно, защото съобщенията там са писани за
 * разработчик ("device not found"). При изпращането на фактури обаче същината е точно в текста: кой
 * клиент няма имейл, коя фактура вече е изпратена. Затова тези извиквания минават със
 * skipErrorInterceptor и идват тук.
 *
 * Показва се само text от отговор с type ERROR, тоест от нарочно хвърлен CustomException. Всичко друго -
 * например провалена SMTP връзка, която идва като type VALIDATION с техническо съдържание в error -
 * пада на общия текст за кода, за да не се сипят Java изключения върху оператора.
 */
export const showBackendError = (error: unknown) => {
    const response = error as Partial<ErrorResponse> | undefined;
    const message = translateClientValidationError(response) || (response?.type === 'ERROR' && typeof response.error === 'string'
        ? response.error.trim()
        : '');

    if (message) {
        toast.error(<CustomToastContent content={[message]} />, toastOptionsTopRight);
        return;
    }

    const code = Number(response?.errorCode);
    const fallbackKey = code > 0 && code < 9 ? `errors.${code}` : 'errors.8';
    toast.error(<CustomToastContent content={[i18n.t(fallbackKey)]} />, toastOptionsTopRight);
};
